<template>
  <b-button
    class="button record-button"
    id="record-button"
    :class="recordButtonClass"
    :disabled="disabled"
  >
    <p class="heading"></p>
    <p><b-icon pack="fas" icon="microphone"></b-icon></p>
  </b-button>
</template>

<script>
import RecordingService from "@/services/recordingService";

export default {
  name: "RecordButton",
  props: ["disabled"],
  data() {
    return {
      lock: false,
      isRecording: false,
      recorder: new RecordingService(),
      minRecordingLengthInSeconds: 0.6
    };
  },
  methods: {
    clickRecordButton() {
      if (this.lock || this.disabled) return;
      this.lock = true;
      if (this.isRecording) {
        this.stopRecording()
          .catch(reason => this.alertErrorStop(reason))
          .finally(() => {
            this.lock = false;
          });
      } else {
        this.startRecording()
          .catch(reason => this.alertErrorStart(reason))
          .finally(() => {
            this.lock = false;
          });
      }
    },
    async stopRecording() {
      if (
        !this.isRecording ||
        this.recorder.getCurrentDuration() < this.minRecordingLengthInSeconds
      )
        return;
      this.isRecording = false;
      const result = await this.recorder.stop();
      this.$emit("recording", result);
    },
    async startRecording() {
      if (this.isRecording) return;
      await this.recorder.start();
      this.isRecording = true;
    },
    alertErrorStart(reason) {
      const generalMessage =
        "Recording couldn't start. Possible cause of this error is not allowing access to your microphone.";
      const iosMessage =
        "If you are using iPhone or iPad, please check <strong>Settings -> Safari -> Microphone</strong> and make sure that the access to the microphone is enabled. Some iOS devices have the microphone disabled by default.";
      const message = this.isIosDevice()
        ? `${generalMessage} ${iosMessage}`
        : generalMessage;
      this.alertError(message, reason);
    },
    alertErrorStop(reason) {
      const message =
        "Something went wrong with the recording. If you see this message all the time, it is possible that your browser or device doesn't have full support or the necessary permissions for audio recording.";
      this.alertError(message, reason);
    },
    alertError(message, reason) {
      this.$buefy.dialog.alert({
        title: "Error",
        message: message,
        type: "is-danger",
        hasIcon: true,
        icon: "times-circle",
        iconPack: "fa",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.$gtag.exception({
        description: `${message} - Reason: ${JSON.stringify(reason)}`,
        fatal: true
      });
    },
    isIosDevice() {
      return (
        (/ipad|iphone|ipod/i.test(window.navigator.userAgent.toLowerCase()) ||
          (navigator.platform === "MacIntel" &&
            navigator.maxTouchPoints > 1)) &&
        !window.MSStream
      );
    }
  },
  computed: {
    recordButtonClass() {
      return this.isRecording ? "is-danger" : "is-info";
    }
  },
  mounted() {
    const button = document.getElementById("record-button");
    const touchEvent = "ontouchstart" in window ? "touchstart" : "click";
    button.addEventListener(touchEvent, this.clickRecordButton);
  },
  beforeDestroy() {
    const button = document.getElementById("record-button");
    if (button) button.onclick = null;
  }
};
</script>

<style lang="scss" scoped>
.record-button {
  width: 100%;
  height: 100%;
}
</style>
